import { SvgIcon, SvgIconProps } from '@mui/material';

export function ActivateSignatureIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 16 16'
      fill='none'
      data-testid='icon-signature'
    >
      <path
        d='M12.6667 13.333H3.33335C3.15654 13.333 2.98697 13.4032 2.86195 13.5283C2.73693 13.6533 2.66669 13.8229 2.66669 13.9997C2.66669 14.1765 2.73693 14.3461 2.86195 14.4711C2.98697 14.5961 3.15654 14.6663 3.33335 14.6663H12.6667C12.8435 14.6663 13.0131 14.5961 13.1381 14.4711C13.2631 14.3461 13.3334 14.1765 13.3334 13.9997C13.3334 13.8229 13.2631 13.6533 13.1381 13.5283C13.0131 13.4032 12.8435 13.333 12.6667 13.333Z'
        fill={props.fill ?? props.color ?? '#3B3C40'}
      />
      <path
        d='M3.33335 12.0002H3.39335L6.17335 11.7469C6.47788 11.7166 6.7627 11.5824 6.98001 11.3669L12.98 5.3669C13.2129 5.12088 13.3387 4.79257 13.33 4.45392C13.3213 4.11527 13.1786 3.7939 12.9333 3.56023L11.1067 1.73356C10.8683 1.50963 10.5559 1.38114 10.2289 1.37253C9.90193 1.36393 9.5832 1.47581 9.33335 1.6869L3.33335 7.6869C3.11786 7.90421 2.98368 8.18903 2.95335 8.49356L2.66668 11.2736C2.6577 11.3712 2.67037 11.4696 2.70379 11.5618C2.73721 11.654 2.79055 11.7377 2.86001 11.8069C2.92231 11.8687 2.99619 11.9176 3.07741 11.9507C3.15864 11.9839 3.24561 12.0007 3.33335 12.0002ZM10.18 2.6669L12 4.4869L10.6667 5.7869L8.88001 4.00023L10.18 2.6669ZM4.24668 8.6069L8.00001 4.88023L9.80001 6.68023L6.06668 10.4136L4.06668 10.6002L4.24668 8.6069Z'
        fill={props.fill ?? '#3B3C40'}
      />
    </SvgIcon>
  );
}
